/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_ThemeInputs */

const en_auto_theme = /** @type {(inputs: Auto_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto`)
};

const fr_auto_theme = /** @type {(inputs: Auto_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto`)
};

const de_auto_theme = /** @type {(inputs: Auto_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto`)
};

const it_auto_theme = /** @type {(inputs: Auto_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto`)
};

const ru_auto_theme = /** @type {(inputs: Auto_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Авто`)
};

const es_auto_theme = /** @type {(inputs: Auto_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto`)
};

const zh_cn2_auto_theme = /** @type {(inputs: Auto_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`汽车`)
};

const ja_auto_theme = /** @type {(inputs: Auto_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オート`)
};

const hi_auto_theme = /** @type {(inputs: Auto_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑटो`)
};

const pt_pt2_auto_theme = /** @type {(inputs: Auto_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto`)
};

/**
* | output |
* | --- |
* | "Auto" |
*
* @param {Auto_ThemeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_theme = /** @type {((inputs?: Auto_ThemeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_ThemeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_auto_theme(inputs)
	if (locale === "de") return de_auto_theme(inputs)
	if (locale === "it") return it_auto_theme(inputs)
	if (locale === "ru") return ru_auto_theme(inputs)
	if (locale === "es") return es_auto_theme(inputs)
	if (locale === "zh-CN") return zh_cn2_auto_theme(inputs)
	if (locale === "ja") return ja_auto_theme(inputs)
	if (locale === "hi") return hi_auto_theme(inputs)
	if (locale === "pt-PT") return pt_pt2_auto_theme(inputs)
	return en_auto_theme(inputs)
});